import { Avatar, Button, CardActions, CardContent, CardHeader, Collapse, Typography } from '@material-ui/core';
import { useRepository } from '@sensenet/hooks-react';
import React, { useEffect, useState } from 'react';
import { useCommentState, useLocalization } from "../../hooks/index.js";
import { CommentCard, DeleteButton } from "./index.js";
/**
 * Comment prop type
 */
const MAX_TEXT_LENGTH = 160;

/**
 * Represents a single comment component.
 */
export const Comment = props => {
  const isLongText = props.comment.text && props.comment.text.length > MAX_TEXT_LENGTH;
  const [isOpen, setIsOpen] = useState(!isLongText);
  const localization = useLocalization();
  const commentState = useCommentState();
  const repo = useRepository();
  const [isSelected, setIsSelected] = useState(props.comment.id === commentState.activeCommentId);
  useEffect(() => {
    setIsSelected(props.comment.id === commentState.activeCommentId);
  }, [commentState.activeCommentId, props.comment.id]);
  return /*#__PURE__*/React.createElement(CommentCard, {
    active: isSelected,
    onClick: () => commentState.setActiveComment(props.comment.id)
  }, /*#__PURE__*/React.createElement(CardHeader, {
    avatar: repo.configuration.repositoryUrl === props.comment.createdBy.avatarUrl ? /*#__PURE__*/React.createElement(Avatar, null) : /*#__PURE__*/React.createElement(Avatar, {
      src: props.comment.createdBy.avatarUrl,
      alt: localization.avatarAlt
    }),
    title: props.comment.createdBy.displayName
  }), /*#__PURE__*/React.createElement(Collapse, {
    in: isOpen,
    timeout: "auto",
    collapsedHeight: isOpen ? '0px' : '78px'
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    style: {
      wordBreak: 'break-word'
    }
  }, props.comment.text))), /*#__PURE__*/React.createElement(CardActions, null, isLongText ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    onClick: () => setIsOpen(!isOpen)
  }, isOpen ? localization.showLess : localization.showMore), isOpen ? /*#__PURE__*/React.createElement(DeleteButton, {
    comment: props.comment
  }) : null) : /*#__PURE__*/React.createElement(DeleteButton, {
    comment: props.comment
  })));
};
//# sourceMappingURL=comment.js.map